import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4de2d34c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4de2d34c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de2d34c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4de2d34c')) {
      api.createRecord('4de2d34c', component.options)
    } else {
      api.reload('4de2d34c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4de2d34c&scoped=true", function () {
      api.rerender('4de2d34c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/data/dashboard/index.vue"
export default component.exports